/* ***************************************
This mixin "exposes" a few computed properties and methods to the /shared/components/account/UserSettingsPopup
drawing mostly from the app's own mixins
(see there for which are currently used)
*************************************** */

import nikudMixins from './nikudMixins'
import serviceMixins from "./serviceMixins"

export default {
  name: 'dictionaryMixins',
  mixins: [nikudMixins, serviceMixins],
  computed: {
    hostGoogleAnalyticsId () {
      return this.googleAnalyticsId
    }
  },
  methods: {
    displayDictionaryText () {
      this.display(arguments)
    },
    hostGtag () {
      this.gtag(arguments)
    }
  }
}
